/* eslint-disable arrow-body-style */
/* eslint-disable vars-on-top */
/* eslint-disable no-plusplus */
/* eslint-disable no-array-constructor */
/* eslint-disable camelcase */
/* eslint-disable no-var */
/* eslint-disable eqeqeq */
/* eslint-disable prefer-const */
/* eslint-disable no-unused-vars */
/* eslint-disable import/extensions */
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import SendIcon from '@mui/icons-material/Send';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import TWLocale from 'date-fns/locale/zh-TW';

// material
import {
  Dialog,
  DialogTitle,
  DialogContentText,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  DialogContent,
  DialogActions,
  Grid,
  Tabs,
  Tab,
  Avatar,
  Chip,
  Autocomplete,
  Paper,
  MenuItem,
  Checkbox,
  InputLabel,
  Stack,
  Box,
  TextField,
  styled,
  Typography,
  Divider,
  Container,
  Snackbar,
  FormControlLabel,
  Switch,
  CardMedia,
  FormControl
} from '@mui/material';

import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

import Select, { SelectChangeEvent } from '@mui/material/Select';

import MuiAlert from '@mui/material/Alert';
import addDays from 'date-fns/addDays';
import { DateRange } from 'react-date-range';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { zhTW } from '@mui/material/locale';
import { TileLayer, MapContainer, LayersControl, Marker, Popup, Tooltip } from 'react-leaflet';
// components
import datetimeobj from 'date-and-time';
import Page from '../components/Page';
import Gridtable from '../components/gridtable';
import EventDialog from '../components/_dashboard/DVR/eventDialog';
import BootpDialog from '../components/_dashboard/DVR/BootpDialog';
import TTable from '../components/TTable';

// 定義Switch外觀
const IOSSwitch = styled((props) => (
  <Switch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...props}
    checked={props.checked}
    onChange={props.onChange}
  />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
        opacity: 1,
        border: 0
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5
      }
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff'
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3
    }
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500
    })
  }
}));

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const maps = {
  base: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: 'left',
  color: theme.palette.text.secondary
}));
const Alert = React.forwardRef((props, ref) => (
  <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
));
// 定義切換頁
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}
const centergps = {
  彰化縣: [24.050666, 120.483982],
  雲林縣: [23.702376, 120.386782]
};
const hour = [
  '00',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23'
];
export default function DVR() {
  const workheadCell = [
    {
      name: 'vehicle',
      title: '車牌'
    },
    {
      name: 'date',
      title: '發生日期'
    },
    {
      name: 'time',
      title: '發生時間'
    },
    {
      name: 'event',
      title: '事件'
    },
    {
      name: 'event_video_url',
      title: '事件連結'
    },
    {
      name: 'extra_info',
      title: '備註'
    },
    {
      name: 'Longitude',
      title: 'X'
    },
    {
      name: 'Latitude',
      title: 'Y'
    },
    {
      name: 'googlelink',
      title: 'GOOGLE連結'
    }
  ];
  const headCell = [
    {
      id: 'vehicle',
      numeric: false,
      disablePadding: false,
      fillter: true,
      label: '車牌'
    },
    {
      id: 'date',
      numeric: false,
      disablePadding: false,
      fillter: true,
      label: '發生日期'
    },
    {
      id: 'time',
      numeric: false,
      disablePadding: false,
      fillter: true,
      label: '發生時間'
    },
    {
      id: 'event',
      numeric: false,
      disablePadding: false,
      fillter: true,
      label: '事件'
    },
    {
      type: 'render',
      fn: (row) => {
        const { leonTagProductNumber, description, updateTime, enable } = row;
        return (
          <Button
            variant="text"
            onClick={() => {
              eventButtonhandleClickOpen(row);
            }}
          >
            查看
          </Button>
        );
      }
    }
  ];
  // 宣告一個新的 state 變數，我們稱作為「count」。
  // 相似於 componentDidMount 和 componentDidUpdate:
  // eslint-disable-next-line prefer-const

  const Region = localStorage.getItem('region');
  const host = localStorage.getItem('apiurl');
  const [reason, setreason] = React.useState(' ');
  const [Datevalue, setDatevalue] = React.useState(new Date());
  const [eventDatevalue, seteventDatevalue] = useState([
    {
      startDate: addDays(new Date(), -7),
      endDate: new Date(),
      key: 'selection'
    }
  ]);
  const [Vehiclelist, setVehiclelist] = React.useState([]);
  // eslint-disable-next-line camelcase
  const [event_message, setevent_message] = React.useState([]);
  const [selecVehicleplate, setSselecVehicleplate] = useState(null);

  const [carno, setcarno] = React.useState('');
  const [value, setValue] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [Buttonopen, setButtonopen] = React.useState(false);
  const [eventButtonopen, seteventButtonopen] = React.useState(false);
  const [hourobj, sethourobj] = React.useState('');
  const [videourl, setvideourl] = React.useState('');
  const [openmap, setopenmap] = useState(null);
  const [openmap1, setopenmap1] = useState(null);
  const [checked, setChecked] = React.useState([]);
  const [eventvideo, seteventvideo] = React.useState([]);
  const [eventcarobj, seteventcarobj] = React.useState({
    vehicle: '',
    event_video_url: '',
    Latitude: 24.050666,
    Longitude: 120.483982
  });
  const [licenseplatestr, setlicenseplatestr] = React.useState('');
  const [headCells, setHeadCells] = useState([]);
  const [autoreflash, setautoreflash] = useState(false);
  const [intervalId, setintervalId] = useState(0);
  const [WORKBTIME, setWORKBTIME] = React.useState(' ');
  const [WORKETIME, setWORKETIME] = React.useState(' ');
  const [rawvideolist, setrawvideolist] = React.useState([]);
  const [rawvideodgopen, setrawvideodgopen] = React.useState(false);
  const [latest_online_time, setlatest_online_time] = React.useState('');
  const [is_online, setis_online] = React.useState('離線');
  // const rawvideolist = useRef([]);
  const rawDatevalue = useRef(new Date());
  const selectrawVehicleplate = useRef(null);
  const rawhourobj = useRef('');
  const [seleceventplate, setseleceventplate] = useState([]);
  const onTagsChange = (event, values) => {
    setseleceventplate(values);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    await setHeadCells(workheadCell);
    await getDVR_event_message();
    await Vehicle_management();
    // 定時讀取車機清單
    // eslint-disable-next-line no-const-assign
    // eslint-disable-next-line react-hooks/exhaustive-deps

    // componentWillUnmount
    return function cleanup() {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (autoreflash) {
      // 更新相機1
      let myintervalId = setInterval(get_raw_video, 120000);
      setintervalId(myintervalId);
    } else {
      clearInterval(intervalId);
    }
  }, [autoreflash, selecVehicleplate, hourobj, Datevalue]);

  const getVehiclestatus = async (carno) => {
    if (carno != null) {
      await axios
        .get(`${host}/api/car/getDvrvehiclestatusbycarno?Region=${Region}&carno=${carno.CAR_NO}`)
        .then(async (response) => {
          // eslint-disable-next-line eqeqeq
          if (response.data.code == 0) {
            await setlatest_online_time(response.data.data.latest_online_time);
            await setis_online(response.data.data.is_online);
          }
        })
        .catch((error) => {
          // handle error
          console.log(error);
        })
        .then(() => {
          // always executed
        });
    } else {
      await setlatest_online_time('');
      await setis_online('離線');
    }
  };
  // eslint-disable-next-line camelcase
  const getdriver_attendancebydate = async (CAR_NO) => {
    const datestr = dateToStrTime(rawDatevalue.current);
    await axios
      .get(
        `${host}api/driver/getdriver_attendancebydate?Region=${Region}&carno=${CAR_NO}&date=${datestr}`
      )
      .then(async (response) => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == 0) {
          setWORKBTIME(response.data.WORK_BTIME);
          setWORKETIME(response.data.WORK_ETIME);
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });
  };
  // 取得事件
  // eslint-disable-next-line camelcase
  const getDVR_event_message = async () => {
    await axios
      .get(`${host}api/DVR/getDVR_event_message`, {
        headers: {
          'content-type': 'application/json'
        }
      })
      .then(async (response) => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == 0) {
          setevent_message(response.data.data);
        } else {
          setreason('讀取token失敗!!');
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });
  };

  // eslint-disable-next-line camelcase
  const get_event_video_list = async () => {
    // eslint-disable-next-line eqeqeq
    const startDatevalue = dateTonetcoreStrTime(eventDatevalue[0].startDate, 0);
    // 結束日期加一天
    var newendDate = new Date(eventDatevalue[0].endDate);
    newendDate = new Date(newendDate.setDate(newendDate.getDate() + 1));
    const endDatevalue = dateTonetcoreStrTime(newendDate, 0);

    let Query = `starttime=${startDatevalue}&enttime=${endDatevalue}`;

    if (seleceventplate.length > 0) {
      let entplatestring = '';
      for (
        let eventplateindex = 0;
        eventplateindex < seleceventplate.length - 1;
        eventplateindex++
      ) {
        entplatestring += `${seleceventplate[eventplateindex].CAR_NO},`;
      }
      entplatestring += `${seleceventplate[seleceventplate.length - 1].CAR_NO}`;
      Query += `&vehicle=${entplatestring}`;
    }
    if (checked.length > 0) {
      const eventstring = checked.toString();
      Query += `&eventtype=${eventstring}`;
    }
    Query += `&Region=${Region}`;
    const url = `${host}api/DVR/getDVR_event?${Query}`;
    await axios
      .get(url, {
        headers: {
          'content-type': 'application/json'
        }
      })
      .then(async (response) => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == 0) {
          let tempresults = [];
          response.data.data.forEach((element) => {
            element.date = tabledateToStrTime(element.event_start_time, 0);
            element.time = tabledateToStrTime(element.event_start_time, 1);

            tempresults.push(element);
          });
          console.log(tempresults);
          seteventvideo(tempresults);
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });
  };
  // eslint-disable-next-line camelcase
  const click_raw_video_search = async () => {
    clearInterval(intervalId);
    // 紀錄每個參數除非從新按下搜尋
    rawDatevalue.current = Datevalue;
    selectrawVehicleplate.current = selecVehicleplate;
    rawhourobj.current = hourobj;
    // 相機一相機二一起更新
    await get_raw_video();
    // 設定工時
    await getdriver_attendancebydate(selectrawVehicleplate.current.CAR_NO);
  };
  // eslint-disable-next-line camelcase
  const get_raw_video = async () => {
    let raw_video1 = [];
    let raw_video2 = [];
    // eslint-disable-next-line eqeqeq
    if (selectrawVehicleplate.current != null && rawhourobj.current != '') {
      console.log(rawDatevalue);
      const datestr = dateToStrTime(rawDatevalue.current);
      console.log(datestr);
      // 相機一
      raw_video1 = await get_raw_video_api(datestr, 1);
      // 相機二
      raw_video2 = await get_raw_video_api(datestr, 2);
      await setrawvideolist([]);
      let temprawvideolist = [];
      // 二微陣列
      for (let raw_videoindex = 0; raw_videoindex < raw_video1.length; raw_videoindex++) {
        let newraw_videoobj = {};
        newraw_videoobj.video_datetime_tz = raw_video1[raw_videoindex].video_datetime_tz;
        newraw_videoobj.minutestring = raw_video1[raw_videoindex].minutestring;
        newraw_videoobj.by_system1 = raw_video1[raw_videoindex].by_system;
        newraw_videoobj.status1 = raw_video1[raw_videoindex].status;
        newraw_videoobj.video_url1 = raw_video1[raw_videoindex].video_url;
        if (newraw_videoobj.status1 == null) {
          newraw_videoobj.str1 = '申請調閱鏡頭 1';
          newraw_videoobj.disabled1 = false;
        } else if (
          newraw_videoobj.status1 == 0 ||
          newraw_videoobj.status1 == 1 ||
          newraw_videoobj.status1 == 2
        ) {
          newraw_videoobj.str1 = '鏡頭 1影片處理中';
          newraw_videoobj.disabled1 = true;
        } else if (newraw_videoobj.status1 == 4) {
          newraw_videoobj.str1 = '車機鏡頭 1無影片';
          newraw_videoobj.disabled1 = true;
        } else {
          newraw_videoobj.str1 = '鏡頭 1';
          newraw_videoobj.disabled1 = false;
        }

        newraw_videoobj.by_system2 = raw_video2[raw_videoindex].by_system;
        newraw_videoobj.status2 = raw_video2[raw_videoindex].status;
        newraw_videoobj.video_url2 = raw_video2[raw_videoindex].video_url;
        if (newraw_videoobj.status2 == null) {
          newraw_videoobj.str2 = '申請調閱鏡頭 2';
          newraw_videoobj.disabled2 = false;
        } else if (
          newraw_videoobj.status2 == 0 ||
          newraw_videoobj.status2 == 1 ||
          newraw_videoobj.status2 == 2
        ) {
          newraw_videoobj.str2 = '鏡頭 2影片處理中';
          newraw_videoobj.disabled2 = true;
        } else if (newraw_videoobj.status2 == 4) {
          newraw_videoobj.str2 = '車機鏡頭 2無影片';
          newraw_videoobj.disabled2 = true;
        } else {
          newraw_videoobj.str2 = '鏡頭 2';
          newraw_videoobj.disabled2 = false;
        }

        temprawvideolist.push(newraw_videoobj);
      }
      await setrawvideolist(temprawvideolist);
      // rawvideolist.current = temprawvideolist;
    } else {
      setrawvideodgopen(true);
    }
  };
  // eslint-disable-next-line camelcase
  const get_raw_video_api = async (datestr, channel) => {
    let raw_video = [];
    const Query = `raw-video/hour?vehicle=${selectrawVehicleplate.current.CAR_NO}&channel=${channel}&date=${datestr}&timezone_name=Asia/Taipei&hour=${rawhourobj.current}`;
    const url = `${host}api/DVR/gettheomnieyes_api?Query=${encodeURIComponent(Query)}`;
    await axios
      .get(url, {
        headers: {
          'content-type': 'application/json'
        }
      })
      .then(async (response) => {
        if (response.data.success) {
          response.data.results.forEach((element) => {
            if (element.minute <= 9) {
              element.minutestring = `0${element.minute}`;
            } else {
              element.minutestring = element.minute;
            }
            raw_video.push(element);
          });
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });
    return raw_video;
  };
  // eslint-disable-next-line camelcase
  const Vehicle_management = async () => {
    await axios
      .get(`${host}api/car/getcar?Region=${Region}`)
      .then(async (response) => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == 0) {
          // handle success
          // eslint-disable-next-line prefer-const
          let resArr = [];
          const set = new Set(response.data.data);
          resArr = Array.from(set);
          await setVehiclelist([]);

          // eslint-disable-next-line no-plusplus
          for (let arrayindex = 0; arrayindex < resArr.length; arrayindex++) {
            resArr[arrayindex].label = resArr[arrayindex].CAR_NO;
            resArr[arrayindex].title = resArr[arrayindex].CAR_NO;
          }
          await setVehiclelist(resArr);
        } else {
          setreason(response.data.message);
          setVehiclelist([]);
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });
  };
  const tabledateToStrTime = (datetime, mode) => {
    datetime = new Date(datetime);
    let returnstr = "";
    // eslint-disable-next-line eqeqeq
    if (mode == 0) {
      returnstr = datetimeobj.format(datetime, 'YYYY-MM-DD');
    } else {
      returnstr = datetimeobj.format(datetime, 'HH:mm:ss');
    }
    return returnstr;
  };
  const dateTonetcoreStrTime = (datetime, mode) => {
    let returnstr = "";
    // eslint-disable-next-line eqeqeq
    if (mode == 0) {
      returnstr = datetimeobj.format(datetime, 'YYYY-MM-DD');
    } else {
      returnstr = datetimeobj.format(datetime, 'YYYY-MM-DD HH:mm:ss');

    }
    return returnstr;
  };
  const dateToStrTime = (datetime) => {
    const value = datetimeobj.format(datetime, 'YYYYMMDD');

    return value;
  };
  // re-usable method
  // eslint-disable-next-line no-extend-native
  Array.prototype.groupBy = function (prop) {
    // eslint-disable-next-line react/no-this-in-sfc
    return this.reduce((groups, item) => {
      const val = item[prop];
      groups[val] = groups[val] || [];
      groups[val].push(item);
      return groups;
    }, {});
  };
  // tab切換
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  // 關閉彈跳釋出
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };
  const eventButtonhandleClickOpen = (carobj) => {
    seteventButtonopen(true);
    seteventcarobj(carobj);
  };
  const eventButtonhandleClose = () => {
    seteventButtonopen(false);
  };
  const ButtonhandleClickOpen = (carid) => {
    setButtonopen(true);
    setcarno(carid);
  };

  const rawvideodgClose = () => {
    setrawvideodgopen(false);
  };
  const ButtonhandleClose = () => {
    setButtonopen(false);
  };
  const selecthandleChange = (event) => {
    sethourobj(event.target.value);
  };
  const videoButtonClick = async (videoobj, channel) => {
    if (channel == 1) {
      if (videoobj.status1 == null) {
        rawvideorrequest(videoobj, channel);
      } else if (videoobj.status1 == 5) {
        setvideourl(videoobj.video_url1);
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (videoobj.status2 == null) {
        rawvideorrequest(videoobj, channel);
      } else if (videoobj.status2 == 5) {
        setvideourl(videoobj.video_url2);
      }
    }
  };
  const rawvideorrequest = async (videoobj, channel) => {
    // 向車機發出請求
    axios
      .get(
        `${host}api/DVR/rawvideorrequest?vehicle=${selectrawVehicleplate.current.CAR_NO}&datetime=${videoobj.video_datetime_tz}&channel=${channel}`,
        {
          headers: {
            'content-type': 'application/json'
          }
        }
      )
      .then((response) => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == 0) {
          // 發送需求成功執行一次搜尋
          get_raw_video();
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });
  };
  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    // eslint-disable-next-line eqeqeq
    if (value == 'all') {
      // eslint-disable-next-line no-lonely-if
      if (currentIndex === -1) {
        // eslint-disable-next-line prefer-arrow-callback
        event_message.forEach(function (messageobj) {
          newChecked.push(messageobj.event_type);
        });
      } else {
        newChecked.length = 0;
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }
    }

    setChecked(newChecked);
  };
  return (
    <Page title="座艙全時紀錄 | 智慧城市移動資訊平台">
      <Container maxWidth="xl">
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
            {reason}
          </Alert>
        </Snackbar>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="事件查詢(圖台呈現)" {...a11yProps(0)} />
          <Tab label="事件查詢(報表呈現)" {...a11yProps(1)} />
          <Tab label="原始影像調閱" {...a11yProps(2)} />
        </Tabs>
        <TabPanel value={value} index={0}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Stack spacing={1.5}>
                <Typography alignItems="center" variant="subtitle2" noWrap>
                  第一步.請選擇日期:
                </Typography>
                <Grid container spacing={0.5}>
                  <DateRange
                    editableDateInputs
                    onChange={async (item) => {
                      await seteventDatevalue([item.selection]);
                    }}
                    moveRangeOnFirstSelection={false}
                    ranges={eventDatevalue}
                    locale={TWLocale}
                  />
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography alignItems="center" variant="subtitle2" noWrap>
                      第二步.請選擇車輛:
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      variant="text"
                      onClick={async () => {
                        for (let arrayindex = 0; arrayindex < Vehiclelist.length; arrayindex++) {
                          setseleceventplate(Vehiclelist[arrayindex]);
                        }
                      }}
                    >
                      全選
                    </Button>
                  </Grid>
                </Grid>
                <Autocomplete
                  multiple
                  limitTags={3}
                  options={Vehiclelist}
                  id="multiple-limit-tags"
                  getOptionLabel={(option) => option.title || option}
                  onChange={onTagsChange}
                  renderInput={(params) => (
                    <TextField {...params} label="選擇車輛" placeholder="選擇車輛" />
                  )}
                />

                <Typography alignItems="center" variant="subtitle2" noWrap>
                  第三步.請選擇事件類別:
                </Typography>
                <Grid container>
                  <Grid item xs={6}>
                    <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                      {event_message.slice(0, 8).map((value) => {
                        const labelId = `checkbox-list-label-${value.event_type}`;
                        return (
                          <ListItem key={value} disablePadding>
                            <ListItemButton
                              role={undefined}
                              onClick={handleToggle(value.event_type)}
                              dense
                            >
                              <ListItemIcon>
                                <Checkbox
                                  edge="start"
                                  checked={checked.indexOf(value.event_type) !== -1}
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{ 'aria-labelledby': labelId }}
                                />
                              </ListItemIcon>
                              <ListItemText id={labelId} primary={` ${value.event_name}`} />
                            </ListItemButton>
                          </ListItem>
                        );
                      })}
                    </List>
                  </Grid>
                  <Grid item xs={6}>
                    <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                      {event_message.slice(8, 15).map((value) => {
                        const labelId = `checkbox-list-label-${value.event_type}`;
                        return (
                          <ListItem key={value} disablePadding>
                            <ListItemButton
                              role={undefined}
                              onClick={handleToggle(value.event_type)}
                              dense
                            >
                              <ListItemIcon>
                                <Checkbox
                                  edge="start"
                                  checked={checked.indexOf(value.event_type) !== -1}
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{ 'aria-labelledby': labelId }}
                                />
                              </ListItemIcon>
                              <ListItemText id={labelId} primary={` ${value.event_name}`} />
                            </ListItemButton>
                          </ListItem>
                        );
                      })}
                    </List>
                  </Grid>
                </Grid>
                <Button
                  sx={{ width: '100%', height: '100%' }}
                  variant="contained"
                  // eslint-disable-next-line camelcase
                  onClick={get_event_video_list}
                >
                  搜尋
                </Button>
              </Stack>
            </Grid>
            <Grid item xs={8}>
              <MapContainer
                center={centergps[Region]}
                whenCreated={setopenmap}
                zoom={11}
                zoomControl={false}
                style={{ height: 700, width: '100%' }}
              >
                <TileLayer
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <MarkerClusterGroup disableClusteringAtZoom={15} removeOutsideVisibleBounds>
                  {eventvideo.map((incident) => {
                    const point = [incident.Latitude, incident.Longitude];
                    return (
                      <Marker
                        position={point}
                        key={incident.FK_UnitID}
                        eventHandlers={{
                          click: (e) => {
                            eventButtonhandleClickOpen(incident);
                          }
                        }}
                      >
                        <Tooltip direction="right" offset={[0, 0]} opacity={1} permanent>
                          {incident.vehicle}
                          {incident.event}
                        </Tooltip>
                      </Marker>
                    );
                  })}
                </MarkerClusterGroup>
              </MapContainer>
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Stack spacing={1.5}>
                <Typography alignItems="center" variant="subtitle2" noWrap>
                  第一步.請選擇日期:
                </Typography>
                <Grid container spacing={0.5}>
                  <DateRange
                    editableDateInputs
                    onChange={async (item) => {
                      await seteventDatevalue([item.selection]);
                    }}
                    moveRangeOnFirstSelection={false}
                    ranges={eventDatevalue}
                    locale={TWLocale}
                  />
                </Grid>
                <Typography alignItems="center" variant="subtitle2" noWrap>
                  第二步.請選擇車輛:
                </Typography>
                <Button
                  variant="text"
                  onClick={async () => {
                    console.log(Vehiclelist);
                    await setseleceventplate(Vehiclelist);
                    console.log(seleceventplate);
                  }}
                >
                  全選
                </Button>
                <Autocomplete
                  multiple
                  limitTags={3}
                  options={Vehiclelist}
                  id="multiple-limit-tags"
                  getOptionLabel={(option) => option.title || option}
                  onChange={onTagsChange}
                  renderInput={(params) => (
                    <TextField {...params} label="選擇車輛" placeholder="選擇車輛" />
                  )}
                />

                <Typography alignItems="center" variant="subtitle2" noWrap>
                  第三步.請選擇事件類別:
                </Typography>
                <Grid container>
                  <Grid item xs={6}>
                    <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                      {event_message.slice(0, 8).map((value) => {
                        const labelId = `checkbox-list-label-${value.event_type}`;
                        return (
                          <ListItem key={value} disablePadding>
                            <ListItemButton
                              role={undefined}
                              onClick={handleToggle(value.event_type)}
                              dense
                            >
                              <ListItemIcon>
                                <Checkbox
                                  edge="start"
                                  checked={checked.indexOf(value.event_type) !== -1}
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{ 'aria-labelledby': labelId }}
                                />
                              </ListItemIcon>
                              <ListItemText id={labelId} primary={` ${value.event_name}`} />
                            </ListItemButton>
                          </ListItem>
                        );
                      })}
                    </List>
                  </Grid>
                  <Grid item xs={6}>
                    <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                      {event_message.slice(8, 15).map((value) => {
                        const labelId = `checkbox-list-label-${value.event_type}`;
                        return (
                          <ListItem key={value} disablePadding>
                            <ListItemButton
                              role={undefined}
                              onClick={handleToggle(value.event_type)}
                              dense
                            >
                              <ListItemIcon>
                                <Checkbox
                                  edge="start"
                                  checked={checked.indexOf(value.event_type) !== -1}
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{ 'aria-labelledby': labelId }}
                                />
                              </ListItemIcon>
                              <ListItemText id={labelId} primary={` ${value.event_name}`} />
                            </ListItemButton>
                          </ListItem>
                        );
                      })}
                    </List>
                  </Grid>
                </Grid>
                <Button
                  sx={{ width: '100%', height: '100%' }}
                  variant="contained"
                  // eslint-disable-next-line camelcase
                  onClick={get_event_video_list}
                >
                  搜尋
                </Button>
              </Stack>
            </Grid>
            <Grid item xs={8}>
              <Gridtable bindlist={eventvideo} headCells={headCells} filename="影像事件列表" />
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <Stack
            direction="column"
            divider={<Divider orientation="horizontal" flexItem />}
            spacing={2}
          >
            <Box>
              <Typography variant="h5" gutterBottom component="div">
                原始影像調閱
              </Typography>
              <Typography variant="body2" gutterBottom component="div">
                本網站之影像紀錄調閱僅限於所長及相關被授權人員。此外，除非得到車管處或法務室之書面或電子郵件同意函外，所有調閱僅供觀看，嚴禁任何複製、翻拍、重製及任何形式的洩漏與分享，違反者將觸犯個人資料保護法、著作權法與刑法並需承擔相關之民事與刑事責任。
              </Typography>
            </Box>
            <Grid container rowSpacing={2} spacing={3}>
              {/* 
           第一層
          */}
              <Grid item xs={4}>
                <Autocomplete
                  disablePortal
                  id="pelte"
                  options={Vehiclelist}
                  sx={{ width: '100%' }}
                  renderInput={(params) => <TextField {...params} label="選擇車牌" />}
                  value={selecVehicleplate}
                  onChange={(_event, newTeam) => {
                    setSselecVehicleplate(newTeam);

                    getVehiclestatus(newTeam);
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <LocalizationProvider locale={TWLocale} dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker
                    size="large"
                    label="選擇查看日期"
                    inputFormat="yyyy-MM-dd"
                    mask="____-__-__"
                    value={Datevalue}
                    onChange={(newValue) => {
                      console.log(newValue);
                      setDatevalue(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={3}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">選擇小時</InputLabel>
                  <Select
                    labelId="demo-plate-select-label"
                    id="demo-plate-select"
                    value={hourobj}
                    onChange={selecthandleChange}
                  >
                    {hour.map((name) => (
                      <MenuItem key={name} value={name}>
                        {name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2}>
                <Button
                  sx={{ width: '100%', height: '100%' }}
                  variant="contained"
                  // eslint-disable-next-line camelcase
                  onClick={click_raw_video_search}
                >
                  搜尋
                </Button>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <Typography variant="body2">{licenseplatestr}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <></>
                </Grid>
                <Grid item xs={2}>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        sx={{ m: 1 }}
                        checked={autoreflash}
                        onChange={(event) => {
                          setautoreflash(!autoreflash);
                        }}
                      />
                    }
                    label="自動刷新影片狀態"
                  />
                </Grid>
              </Grid>
              {/* 
           第二層
          */}
              <Grid item xs={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Grid item xs={12}>
                      <Typography variant="h5">上線狀態:{is_online}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h5">最後上線時間:{latest_online_time}</Typography>
                    </Grid>

                    <Typography variant="h5">
                      司機工時:{WORKBTIME}~{WORKETIME}
                    </Typography>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography>時間00分到14分</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        {rawvideolist.slice(0, 15).map((rawvideoobj) => {
                          return (
                            // eslint-disable-next-line react/jsx-key
                            <Item>
                              <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent="space-between"
                                mb={0.5}
                              >
                                <Typography variant="h6" gutterBottom>
                                  {hourobj}:{rawvideoobj.minutestring}
                                </Typography>
                                <Button size="small" disabled={rawvideoobj.disabled1}>
                                  <Typography
                                    variant="body2"
                                    onClick={() => videoButtonClick(rawvideoobj, 1)}
                                    gutterBottom
                                  >
                                    {rawvideoobj.str1}
                                  </Typography>
                                </Button>
                                <Button size="small" disabled={rawvideoobj.disabled2}>
                                  <Typography
                                    variant="body2"
                                    onClick={() => videoButtonClick(rawvideoobj, 2)}
                                    gutterBottom
                                  >
                                    {rawvideoobj.str2}
                                  </Typography>
                                </Button>
                              </Stack>
                            </Item>
                          );
                        })}
                      </AccordionDetails>
                    </Accordion>
                  </Grid>
                  <Grid item xs={12}>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                      >
                        <Typography>時間15分到29分</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        {rawvideolist.slice(15, 30).map((rawvideoobj) => {
                          return (
                            // eslint-disable-next-line react/jsx-key
                            <Item>
                              <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent="space-between"
                                mb={0.5}
                              >
                                <Typography variant="h6" gutterBottom>
                                  {hourobj}:{rawvideoobj.minutestring}
                                </Typography>
                                <Button size="small" disabled={rawvideoobj.disabled1}>
                                  <Typography
                                    variant="body2"
                                    onClick={() => videoButtonClick(rawvideoobj, 1)}
                                    gutterBottom
                                  >
                                    {rawvideoobj.str1}
                                  </Typography>
                                </Button>
                                <Button size="small" disabled={rawvideoobj.disabled2}>
                                  <Typography
                                    variant="body2"
                                    onClick={() => videoButtonClick(rawvideoobj, 2)}
                                    gutterBottom
                                  >
                                    {rawvideoobj.str2}
                                  </Typography>
                                </Button>
                              </Stack>
                            </Item>
                          );
                        })}
                      </AccordionDetails>
                    </Accordion>
                  </Grid>
                  <Grid item xs={12}>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                      >
                        <Typography>時間30分到44分</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        {rawvideolist.slice(30, 45).map((rawvideoobj) => {
                          return (
                            // eslint-disable-next-line react/jsx-key
                            <Item>
                              <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent="space-between"
                                mb={0.5}
                              >
                                <Typography variant="h6" gutterBottom>
                                  {hourobj}:{rawvideoobj.minutestring}
                                </Typography>
                                <Button size="small" disabled={rawvideoobj.disabled1}>
                                  <Typography
                                    variant="body2"
                                    onClick={() => videoButtonClick(rawvideoobj, 1)}
                                    gutterBottom
                                  >
                                    {rawvideoobj.str1}
                                  </Typography>
                                </Button>
                                <Button size="small" disabled={rawvideoobj.disabled2}>
                                  <Typography
                                    variant="body2"
                                    onClick={() => videoButtonClick(rawvideoobj, 2)}
                                    gutterBottom
                                  >
                                    {rawvideoobj.str2}
                                  </Typography>
                                </Button>
                              </Stack>
                            </Item>
                          );
                        })}
                      </AccordionDetails>
                    </Accordion>
                  </Grid>
                  <Grid item xs={12}>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                      >
                        <Typography>時間45分到59分</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        {rawvideolist.slice(45, 60).map((rawvideoobj) => {
                          return (
                            // eslint-disable-next-line react/jsx-key
                            <Item>
                              <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent="space-between"
                                mb={0.5}
                              >
                                <Typography variant="h6" gutterBottom>
                                  {hourobj}:{rawvideoobj.minutestring}
                                </Typography>
                                <Button size="small" disabled={rawvideoobj.disabled1}>
                                  <Typography
                                    variant="body2"
                                    onClick={() => videoButtonClick(rawvideoobj, 1)}
                                    gutterBottom
                                  >
                                    {rawvideoobj.str1}
                                  </Typography>
                                </Button>
                                <Button size="small" disabled={rawvideoobj.disabled2}>
                                  <Typography
                                    variant="body2"
                                    onClick={() => videoButtonClick(rawvideoobj, 2)}
                                    gutterBottom
                                  >
                                    {rawvideoobj.str2}
                                  </Typography>
                                </Button>
                              </Stack>
                            </Item>
                          );
                        })}
                      </AccordionDetails>
                    </Accordion>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={8}>
                <CardMedia component="video" image={videourl} controls />
              </Grid>
            </Grid>
          </Stack>
        </TabPanel>
      </Container>
      <EventDialog
        eventcarobj={eventcarobj}
        Buttonopen={eventButtonopen}
        ButtonhandleClose={eventButtonhandleClose}
        setreason={setreason}
      />
      <BootpDialog
        carno={carno}
        Buttonopen={Buttonopen}
        ButtonhandleClose={ButtonhandleClose}
        setreason={setreason}
      />
      <Dialog
        open={rawvideodgopen}
        onClose={rawvideodgClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">尚未選擇車牌或時間</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">請選擇車牌或時間</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={rawvideodgClose}>關閉</Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}
